import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-lg" }, "Editar Grupo")
], -1)
const _hoisted_2 = { class: "px-2" }

import { PropType, ref, onBeforeUnmount, onUpdated } from 'vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { storeToRefs } from 'pinia'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import { useGroupStore } from '@/pinia-store/useGroupStore'
import { useToast } from 'vue-toastification'
import { CreateGroupRequest } from '@/Network/Types/Requests/GroupRequests'
import { GroupResponse } from '@/Network/Types/Responses/GroupResponses'
import BaseForm from './components/base.form.vue'
import { useErrorToast } from '@/composables/useErrorToast'


export default /*#__PURE__*/_defineComponent({
  __name: 'update.group.modal',
  props: {
  group: {
    type: Object as PropType<GroupResponse>,
    default: null
  }
},
  setup(__props) {

const props = __props;

const modalName = EModals.UPDATE_GROUP_MODAL
const { modals } = storeToRefs(useModalStore())
const modalStore = useModalStore()
const handleToggleModal = () => {
  modalStore.toggleModal(modalName)
}
const toast = useToast()
const { notifyError } = useErrorToast()
const groupStore = useGroupStore()



const isLoading = ref(false)
const company = ref<string | null>(null)
const name = ref<string>('')
const email = ref<string>('')
const users = ref<string[]>([])

onUpdated(() => {
  if (props.group) {
    company.value = String(props.group.company?.id)
    name.value = props.group.name ?? ''
    email.value = props.group.email ?? ''
    users.value = props.group.userGroups?.map(({ user }) => String(user.id)) ?? []
  }
})

const handleUpdate = async () => {
  try {
    isLoading.value = true
    const payload: CreateGroupRequest = {
      name: name.value,
      email: email.value,
      companyId: Number(company.value),
      users: users.value.map((u) => Number(u))
    }
    await groupStore.update({ groupId: props.group.id, payload })
    toast.success('Grupo editado com sucesso')
    handleToggleModal()
    clearAllInputs()
  } catch (error) {
    notifyError(error, 'Não foi possível atualizar o grupo.')
  } finally {
    isLoading.value = false
    await groupStore.getAllGroups()
  }
}

const clearAllInputs = () => {
  name.value = ''
  email.value = ''
  company.value = null
  users.value = []
}

onBeforeUnmount(() => {
  clearAllInputs()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleToggleModal,
    modalActive: _unref(modals)[_unref(modalName)],
    hasFooterBorder: true,
    hasHeaderBorder: true,
    width: "700px"
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(OutlineButton, {
                onClick: handleToggleModal,
                width: "100%",
                text: "Cancelar"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(FilledButton, {
                loading: isLoading.value,
                onClick: handleUpdate,
                text: "Salvar Alterações",
                height: "52px",
                width: "100%"
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseForm, {
          name: name.value,
          "onUpdate:name": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
          email: email.value,
          "onUpdate:email": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
          company: company.value,
          "onUpdate:company": _cache[2] || (_cache[2] = ($event: any) => ((company).value = $event)),
          users: users.value,
          "onUpdate:users": _cache[3] || (_cache[3] = ($event: any) => ((users).value = $event)),
          isUpdateGroup: true
        }, null, 8, ["name", "email", "company", "users"])
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})